import React from 'react';
import styled from '@emotion/styled';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col as GridCol } from '../../components/Grid';
import Button from '../../components/Button';
import * as T from '../../components/Typography';
import * as S from './style';
import Image from '../../components/Image';
import { navRoutes } from '../../constants';

const Col = styled(GridCol)`
  min-width: 250px;
`;

const data = {
  member1: {
    title: 'Take a look at opportunities in your area',
    to: navRoutes.tempoWebsite,
    img: 'ctaFootball',
    button: 'Get started today',
    right: '0%',
  },
  member2: {
    title: 'Take a look at opportunities in your area',
    to: navRoutes.tempoWebsite,
    img: 'ctaGardening',
    button: 'Get started today',
  },
  spendPartner1: {
    title: 'Getting started is quick and easy',
    to: navRoutes.spendPartnerForm,
    img: 'ctaGallery',
    button: 'Join us today',
    scale: 1.3,
    top: '90%',
  },
  spendPartner2: {
    title: 'Getting started is quick and easy',
    to: navRoutes.spendPartnerForm,
    img: 'ctaCinema',
    button: 'Join us today',
    right: '-5%',
    scale: 1.1,
  },
  earnGroup1: {
    title: 'We’ll create a package to suit your needs and budget',
    to: navRoutes.earnGroupsForm,
    img: 'ctaReading',
    button: 'Join our network today',
    scale: 1.7,
    top: '70%',
  },
  earnGroup2: {
    title: 'We’ll create a package to suit your needs and budget',
    to: navRoutes.earnGroupsForm,
    img: 'ctaGroup',
    button: 'Join our network today',
    top: '75%',
    scale: 1.5,
    right: '20px',
  },
  commissioner1: {
    title: 'Improve social outcomes and drive impact',
    to: navRoutes.commissionersForm,
    img: 'ctaPainting',
    button: 'Get in touch today',
    top: '70%',
    scale: 1.3,
  },
  commissioner2: {
    title: 'Improve social outcomes and drive impact',
    to: navRoutes.commissionersForm,
    img: 'ctaGardening',
    button: 'Get in touch today',
  },
  TCWalesWelsh: {
    title: 'Mwynhewch weithgareddau hwylus, heb wario arian!',
    to: navRoutes.contactUsForm,
    img: 'ctaGallery',
    button: 'Darganfyddwch fwy',
    scale: 1.3,
    top: '90%',
  },
  TCWalesEnglish: {
    title: 'Enjoy fun activities, without spending money!',
    to: navRoutes.contactUsForm,
    img: 'ctaGallery',
    button: 'Find out more',
    scale: 1.3,
    top: '90%',
  },
  TCEngland: {
    title: 'Find out more about commissioning a programme ',
    to: navRoutes.commissioners,
    img: 'ctaYoga',
    button: 'Find out more',
    scale: 1.3,
    top: '39%',
    isExternal: false,
  },
};

const ActionCardsSection = ({ type }) => {
  const item = data[type];
  const { isExternal = true } = item;
  return (
    <S.Wrapper>
      <SectionLayout bgcolor="gray2">
        <Row jcT="center">
          <Col w={[4, 4, 6]} mt={2}>
            <T.H3 color="midnight" taT="center" taM="center" as="pre">
              {item.title}
            </T.H3>
          </Col>
        </Row>
        <Row jcT="center" mt={5}>
          <Col w={[4, 3, 4]}>
            <Button gradient="pinkGrad" to={item.to} large external={isExternal} caps={false}>
              {item.button}
            </Button>
          </Col>
        </Row>
      </SectionLayout>
      <S.ImageWrapper right={item.right} top={item.top} scale={item.scale}>
        <Image image={item.img} />
      </S.ImageWrapper>
    </S.Wrapper>
  );
};

export default ActionCardsSection;
